(function (w) {
    const ss = w.siteScripts = {};

    //Converts
    ss.converters = {};

    ss.converters.add = function (collection, converter) {
        let col = ss.converters[collection];
        if (!col) { col = ss.converters[collection] = []; }
        col.push(converter);
    };

    ss.converters.apply = function (collection, data) {
        const col = ss.converters[collection];
        if (!col) { return data; }
        col.forEach(function (f) { data = f(data); });
        return data;
    };
})(window);